<template>
  <div class="main">
    <van-nav-bar
      right-text="交卷"
      left-arrow
      @click-left="back"
    >
      <template #title>
        <div class="title" @click="titleTap()">
          {{ type.text }}<van-icon name="arrow-down" color="#7d7e80" size="12" />
        </div>
      </template>
      <template #right>
        <div >共计{{piezf}}道错题</div>
      </template>
    </van-nav-bar>

    <div class="name-num"  >
      <p>{{kcmc}}</p>
      <div><span>{{ curIndex + 1 }}</span>/{{ curTotal }}</div>
    </div>
    <van-empty v-if="isempty" description="暂无数据" />
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <div class="content">
      <!-- 单选题 -->
      <single-opt v-if="data[type.value].typeid == '1' " :multiple="false" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 多选题 -->
      <single-opt v-if="data[type.value].typeid == '2'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 判断题 -->
      <true-or-false v-if="data[type.value].typeid == '3'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in v-if="data[type.value].typeid == '4'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 问答题 -->
      <q-and-a v-if="data[type.value].typeid == '5'"    :data="data[type.value].PaperInfotabList" :active="curIndex" :paper-id="paperId" />
      <!-- 理解题 -->
      <comprehension v-if="data[type.value].typeid == '6'"   :paper-id="paperId" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 不定项选择题 -->
      <single-opt v-if="data[type.value].typeid == '7'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!--排序题 8-->
      <px-info v-if="data[type.value].typeid == '8'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in v-if="data[type.value].typeid == '9'"   :data="data[type.value].PaperInfotabList" :active="curIndex" />

      <q-and-a v-if="parseInt(data[type.value].typeid==null || data[type.value].typeid=='' ? '0' : data[type.value].typeid) > 9 "    :data="data[type.value].PaperInfotabList" :active="curIndex" :paper-id="paperId" />

    </div>

    <!-- 题型 -->
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker
        title="题型"
        show-toolbar
        :columns="typeoption"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <van-tabbar v-model="active" active-color="#7d7e80">
      <van-tabbar-item icon="arrow-left" @click="alterNum('last')">上一题</van-tabbar-item>
      <van-tabbar-item icon="share" @click="back">返回</van-tabbar-item>
      <van-tabbar-item icon="arrow" @click="alterNum('next')">下一题</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
  import singleOpt from '../teacherpage/cuotijicomm/singleOpt'
  import TrueOrFalse from '../teacherpage/cuotijicomm/trueOrFalse.vue'
  import fillIn from '../teacherpage/cuotijicomm/fillIn.vue'
  import qAndA from '../teacherpage/cuotijicomm/qAndA.vue'
  import PxInfo from '../teacherpage/cuotijicomm/pxinfo.vue'
  import comprehension from '../teacherpage/cuotijicomm/comprehension.vue'
  import sf from '../../utils/somefun.js';
  import {Dialog, Notify} from 'vant';

  var timectrl = sf.tc;
  export default {
    components: {
      singleOpt,
      TrueOrFalse,
      fillIn,
      qAndA,
      comprehension,
      PxInfo
    },
    data() {
      return {
        type: {
          text: '单选题',
          value: 0
        },
        curIndex: 0,
        curTotal: 0,
        isempty:false,
        loading:true,
        active: 0,
        kcmc:null,
        show: false,
        typeoption: [],
        title: '',
        data: [{PaperInfotabList:[],typename:'',typeid:''}],
        paperinfo:{},
        pcorphone:null,
        paperId:null,
        paperValue: null,
        piezf:0,
        zf:0,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10000,
          orderColumn:'exam_type_id',
          orderState:'asc',
        },
        // 表单参数
        form: {
          paperId:null,
          ksmxid:null,
          taskid:null,
        }
      }
    },
    created() {
      localStorage.setItem('currentpath', this.$router.currentRoute.fullPath);
      this.getLiastPaperInfo();
    },
    methods: {
      /** 查询试卷试题列表 */
      getLiastPaperInfo(){
        let that = this;
        let datas = {params:that.queryParams}
        this.$ajax.get("/student/ctkstudent/list",datas).then(response => {
          let rows =  response.rows
          if(rows.length==0)
          {
            that.isempty=true;
            that.loading=false;
            return;
          }
          console.log(response.rows)
          let PaperInfotabList = new Array();
          that.data = new Array();
          for(let i = 0;i < rows.length;i++) {
            that.piezf++;
            if (i == 0) {
              PaperInfotabList.push(rows[i]);
            } else {
              if (rows[i].examtypeid != rows[i - 1].examtypeid) {
                that.data.push({
                  PaperInfotabList: PaperInfotabList,
                  typename: rows[i-1].examtypedesc,
                  typeid: rows[i-1].examtypeid
                });
                PaperInfotabList = new Array();
                PaperInfotabList.push(rows[i]);
              } else {
                PaperInfotabList.push(rows[i]);
              }
              if(rows.length==i+1)
              {
                that.data.push({
                  PaperInfotabList: PaperInfotabList,
                  typename: rows[i].examtypedesc,
                  typeid: rows[i].examtypeid
                });
                PaperInfotabList = new Array();
              }
            }
          }
          for(let i = 0;i < that.data.length;i++) {
            that.typeoption.push({text: that.data[i].typename, value: i});
            //默认一个
            if (i == 0) {
              that.type.text = that.data[i].typename;
              that.type.value = i;
              that.curTotal = that.data[i].PaperInfotabList.length;
              this.kcmc = this.data[this.type.value].PaperInfotabList[this.curIndex].kcmc
            }
          }

          console.log("拼装数据：",that.data)
          that.loading=false;
        });
      },
      calcActive() {
        this.curTotal = this.data[this.type.value].PaperInfotabList.length
      },
      aletrType(type) {
        if (type === 'next') {
          if (this.type.value < this.data.length && this.type.value != this.data.length - 1) {
            this.curIndex = 0
            this.type.value++
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive();
          } else {
            this.$toast('没有更多')
          }
        }
        if (type === 'last') {
          if (this.type.value > 0) {
            this.type.value--
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive()
            this.curIndex = this.curTotal - 1
          } else {
            this.$toast('没有更多')
          }
        }

      },
      alterNum(type) {
        if (type === 'next') {
          if (this.curIndex < this.curTotal - 1) {
            this.curIndex++
          } else {
            // 进入下一题型
            this.aletrType(type)
          }
        }
        if (type === 'last') {
          if (this.curIndex > 0) {
            this.curIndex--
          } else {
            this.aletrType(type)
          }
        }
        this.kcmc = this.data[this.type.value].PaperInfotabList[this.curIndex].kcmc
        console.log("下一题长度显示：", this.type.value + " 总长度 " + this.data.length);
        console.log(type)
      },
      titleTap() {
        this.curIndex = 0
        this.show = true
      },
      dropdownChange() {

      },
      onConfirm(e) {
        this.type = e
        this.show = false
        this.calcActive()
        console.log(e)
      },
      onCancel() {

      },
      back()
      {
        this.$router.go(-1)
      }
    }
  }
</script>
<style lang="scss">
  .main{
    .title{
      i{
        margin-left: .1875rem;
      }
    }
    i.van-icon-clock{
      margin-right: .1875rem;
    }
    .name-num{
      margin: 0 .625rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: .0625rem dashed rgb(235, 234, 234);
      span{
        font-size: 1.875rem;
        color: #7469F8;
      }
    }
    .content{
      padding: 0 .625rem;
    }
  }
  .imgshowdiv{
    position: fixed;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;

    z-index: 555;
  }
  .facelayer {
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 999;
  }
  .jjclass{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/studentpage/cuotiku.vue